
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jALIO", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $e43665a982b6e7bd$export$6503ec6e8aabbaf; }, function (v) { return $e43665a982b6e7bd$export$6503ec6e8aabbaf = v; });
var $e43665a982b6e7bd$export$6503ec6e8aabbaf;
var $e43665a982b6e7bd$export$f7ad0328861e2f03;
"use strict";
var $e43665a982b6e7bd$var$mapping = new Map();
function $e43665a982b6e7bd$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$e43665a982b6e7bd$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $e43665a982b6e7bd$var$resolve(id) {
    var resolved = $e43665a982b6e7bd$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$e43665a982b6e7bd$export$6503ec6e8aabbaf = $e43665a982b6e7bd$var$register;
$e43665a982b6e7bd$export$f7ad0328861e2f03 = $e43665a982b6e7bd$var$resolve;

});

var $43f1a7671d8e8dc1$exports = {};

(parcelRequire("jALIO")).register(new URL("", import.meta.url).toString(), JSON.parse('["50iJS","index.e4c09d66.js","kIVNR","carLogo.e02ef99a.svg"]'));


//# sourceMappingURL=index.runtime.df112807.js.map
